import React from "react";
import InsightsCard from "@scripts/frontend/insights/components/InsightsCard";
import LargeFeatureCard from "@scripts/frontend/insights/components/LargeFeatureCard";
import { ElasticBlogResult } from "@scripts/frontend/types/elastic-blog-result";
import clsx from "clsx";


const InsightsRow: React.FC<{ posts: ElasticBlogResult[]; baseUrl: string; alignment: 'left' | 'right' | null }> = ({ posts, baseUrl, alignment }) => {
  const [firstPost, ...otherPosts] = posts;
  const classes = clsx({
    [`is-aligned-${alignment}`]: alignment !== null,
    ['p-post-archive__row']: true,
  });

  return (
    <div className={classes}>
      {firstPost && (
        // NOTE: Disable the large feature card for now.
        // <LargeFeatureCard post={firstPost} baseUrl={baseUrl} />
        <InsightsCard post={firstPost} baseUrl={baseUrl} />
      )}
      {otherPosts.map((post, index) => (
        <InsightsCard key={index} post={post} baseUrl={baseUrl} />
      ))}
    </div>
  );
}

export default InsightsRow;
